// src/version.js — LA VERSION QU'ON MONTRE.
//
// Une seule source pour ce que l'écran affiche (bas de la barre latérale,
// teasing d'entrée). package.json la porte aussi, à la même valeur : on ne
// peut pas l'importer d'ici (hors de src/), donc on la recopie et on la tient.
// Changer de version = changer les deux, dans le même commit.
export const VERSION = '0.1';
